const SESSION_ID_REGEX = /^[a-z0-9]{4}$/i;

const DEV_HTTP_BASE = "http://localhost:8787";

export const normalizeSessionId = (value: string) => value.trim().toUpperCase();

export const isValidSessionId = (value: string) => SESSION_ID_REGEX.test(value);

const stripTrailingSlash = (value: string) => value.replace(/\/$/, "");

export const getCollabHttpBase = () => {
  const env = import.meta.env.VITE_COLLAB_HTTP as string | undefined;
  if (env) return stripTrailingSlash(env);
  if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
    return DEV_HTTP_BASE;
  }
  return stripTrailingSlash(window.location.origin);
};

export const getCollabWsBase = () => {
  const env = import.meta.env.VITE_COLLAB_WS as string | undefined;
  if (env) return stripTrailingSlash(env);
  return getCollabHttpBase().replace(/^http/i, "ws");
};

export const getCollabWsUrl = () => `${getCollabWsBase()}/ws`;

export const createSession = async (): Promise<string> => {
  const response = await fetch(`${getCollabHttpBase()}/api/sessions`, {
    method: "POST",
    headers: { "Content-Type": "application/json" }
  });
  if (!response.ok) {
    throw new Error("Unable to create session.");
  }
  const data = (await response.json()) as { sessionId?: string };
  if (!data.sessionId || !isValidSessionId(data.sessionId)) {
    throw new Error("Invalid session id response.");
  }
  return normalizeSessionId(data.sessionId);
};
